import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MentorModel } from 'common/models/page-models/mentor/mentor-data-model';
import { MentorListingModel } from 'common/models/page-models/mentor/mentor-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { MentorGridWidgetService } from 'common/widget/mentor/mentor-grid-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class MentorGridResolver extends GridResolver<MentorModel, MentorListingModel> {
    constructor(
        protected fs: MentorGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}